import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'

import Text from '../../../typography/Text'

import catRidingDinosaur from '../../assets/santa-cat-riding-dinosaur.svg'
import { shouldShowHiatusNotice } from '../../helpers/hiatusNoticeHelpers'

import styles from './styles'

const HiatusNotice = ({ size = 'small', className, content, dateRange }) => {
  if (!shouldShowHiatusNotice(dateRange)) return null

  return (
    <Text className={cx(styles.container(size), className)}>
      <img width={size === 'small' ? 65 : 104} className={styles.image} src={catRidingDinosaur} alt="" />

      <p className={styles.title(size)}>
        <strong>We’re taking our festive season break</strong>
      </p>

      <div className={styles.content(size)}>
        <p>
          Season’s greetings! Our team is taking a little break for the holiday season between
          <strong>{dateRange.display}</strong>.
        </p>
        {/* eslint-disable-next-line react/no-danger */}
        <p dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    </Text>
  )
}

HiatusNotice.propTypes = {
  size: PropTypes.oneOf(['small', 'large']),
  className: PropTypes.string,
  content: PropTypes.string,
  dateRange: PropTypes.shape({
    display: PropTypes.string,
  }),
}

export default HiatusNotice
